var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.000000, -1063.000000) translate(140.000000, 1064.000000) translate(17.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 1.05,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.895,
    cy: 5.59,
    r: 5.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,14.365 L13.29,14.365 C14.6707119,14.365 15.79,15.4842881 15.79,16.865 L15.79,20.68 L0,20.68 L0,16.865 C0,15.4842881 1.11928813,14.365 2.5,14.365 Z",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPerson);
export default __webpack_public_path__ + "static/media/form-person.0de38c2019b98723f933c423e76665cf.svg";
export { ForwardRef as ReactComponent };